import type { DeleteConsequencesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteConsequencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteConsequences = createMutationHook({
  name: 'deleteConsequences',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.consequence.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  invalidate: (trpc) => [
    trpc.frontend.consequence.register.queryKey(),
    trpc.frontend.consequence.consequenceById.queryKey(),
    trpc.frontend.consequence.getByParentIssueId.queryKey(),
    // COI-889: the left-nav badge reads this count family.
    trpc.frontend.consequence.consequenceCount.queryKey(),
  ],
  mapResponse: (result: {
    deletedCount: number;
  }): DeleteConsequencesMutation => ({
    delete_consequence: {
      __typename: 'consequence_mutation_response',
      affected_rows: result.deletedCount,
    },
  }),
  graphqlDocument: DeleteConsequencesDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['consequence', 'consequence_aggregate'],
});
